var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('order-form',{attrs:{"url":_vm.url,"result-router-name":"yxresult","business-type":"yx"}})}
var staticRenderFns = []

export { render, staticRenderFns }